import * as React from "react";
import { SVGProps } from "react";
const SvgMore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 23a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0-10a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0-10a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMore;
